import src from "IMAGE";
export default { src, width: 200, height: 200, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRlIAAABXRUJQVlA4TEUAAAAvB8ABAM1VICICHgi2DQAAAIAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB9DTDgCAiMgn3yAjDUEmVDbUcgAA"};
